import { dataIdCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconIdCircle = /*#__PURE__*/createIcon(dataIdCircle)
export default IconIdCircle
